import React, { createContext, ReactNode, useContext, useReducer } from 'react';

import {
  BreedersAction,
  breedersInitState,
  breedersReducer,
  BreedersState,
} from 'dogpark/reducers/breeders/BreedersReducer';

type DispatchBreeders = (action: BreedersAction) => void;

const BreedersContext = createContext<
  { state: BreedersState; dispatch: DispatchBreeders } | undefined
>(undefined);

interface BreedersProviderProps {
  children: ReactNode;
  reducerInitialState?: BreedersState;
}

export function BreedersProvider(props: BreedersProviderProps) {
  const { children, reducerInitialState } = props;
  const initialState = reducerInitialState ?? breedersInitState;

  const [state, dispatch] = useReducer(breedersReducer, initialState);

  return (
    <BreedersContext.Provider value={{ state, dispatch }}>
      {children}
    </BreedersContext.Provider>
  );
}

export function useBreedersContext() {
  const context = useContext(BreedersContext);
  if (!context)
    throw new Error('useBreedersContext must be used within a BreedersProvider');
  return context;
}
